<template>
  <Head>
    <title>
      Актуальные цены и доступные планировки ЖК «Сенсация» - бронируйте у
      застройщика
    </title>
    <meta
      name="description"
      content="Планировки квартир комфорт-класса жилого комплекса «Сенсация»."
    />
  </Head>
  <FlatsSearch />
  <ChooseFlatsBanner />
</template>

<script>
import FlatsSearch from "@/components/FlatsSearch.vue";
import ChooseFlatsBanner from "@/components/ChooseFlatsBanner.vue";
import { Head } from "@vueuse/head";
export default {
  components: {
    Head,
    FlatsSearch,
    ChooseFlatsBanner,
  },
  inject: ["mainStore"],
  mounted() {
    // this.$vfm.show({
    //   component: 'PopupAparts',
    // })
  },
};
</script>
